function read(name, cookies = document.cookie) {
  const nameEQ = name + "=";
  const ca = cookies.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function hasConsent(consentLevel) {
  const termsFeedConsentLevel = read("cookie_consent_level");
  let consent = false;

  // Accepted consentLevel param are "strictly-necessary", "functionality", "tracking" and "targeting"
  if (termsFeedConsentLevel) {
    const consentString = decodeURIComponent(termsFeedConsentLevel);
    const startIndex =
      consentString.indexOf(consentLevel) + consentLevel.length + 2;
    const consentValueSubstr = consentString.substring(
      startIndex,
      startIndex + 5
    ); // should return "true," or "false"
    consent = consentValueSubstr.includes("true");
  }

  return consent;
}

function update(name, value, days, sameSite = "Lax", consentLevel) {
  const consent = hasConsent(consentLevel);

  if (consent) {
    create(name, value, days, sameSite);
  } else {
    clear(name);
  }
}

function create(name, value, days, sameSite = "Lax") {
  let expires = "";

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `expires=${date.toGMTString()}; `;
  }

  const sameSiteValue = sameSite ? `SameSite=${sameSite}; ` : "";
  const path = "path=/; ";

  document.cookie = `${name}=${value}; ${expires}${path}${sameSiteValue}`;
}

function clear(name) {
  create(name, "", -1);
}

function listenConsentChange(callback, interval = 1000) {
  let lastCookie = document.cookie;
  setInterval(() => {
    let cookie = document.cookie;
    if (cookie !== lastCookie) {
      try {
        if (
          read("cookie_consent_level") !==
          read("cookie_consent_level", lastCookie)
        ) {
          callback();
        }
      } finally {
        lastCookie = cookie;
      }
    }
  }, interval);
}

module.exports = {
  clear,
  hasConsent,
  listenConsentChange,
  read,
  update,
};



//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/cookies-utils/index.js
// module id = 10
// module chunks = 0